const MARKER_TIMEOUT_MS = 500;
const MARKER_PATH = 'marker';

let _settled = false;
let _cachedValue = null;
let _inFlight = null;

export function readGlobalMarkerCached(base) {
    if (_settled) return Promise.resolve(_cachedValue);
    if (_inFlight) return _inFlight;
    _inFlight = readGlobalMarker(base).then((value) => {
        _inFlight = null;
        _settled = true;
        _cachedValue = typeof value === 'string' && value ? value : null;
        return _cachedValue;
    });
    return _inFlight;
}

export function readGlobalMarker(base) {
    return new Promise((resolve) => {
        let markerOrigin;
        try {
            markerOrigin = new URL(base).origin;
        } catch (e) {
            resolve(null);
            return;
        }

        let settled = false;
        let iframe = null;

        const cleanup = () => {
            window.removeEventListener('message', onMessage);
            if (iframe && iframe.parentNode) iframe.parentNode.removeChild(iframe);
        };

        const finish = (value) => {
            if (settled) return;
            settled = true;
            clearTimeout(timer);
            cleanup();
            resolve(value);
        };

        const onMessage = (event) => {
            if (event.origin !== markerOrigin) return;
            const data = event.data;
            if (!data || data.type !== 'rs-marker') return;
            finish(typeof data.marker === 'string' && data.marker ? data.marker : null);
        };

        const timer = setTimeout(() => finish(null), MARKER_TIMEOUT_MS);

        try {
            window.addEventListener('message', onMessage);
            iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.setAttribute('aria-hidden', 'true');
            iframe.src = `${markerOrigin}/${MARKER_PATH}`;
            iframe.onload = () => {
                try {
                    iframe.contentWindow.postMessage({ type: 'rs-marker-request' }, markerOrigin);
                } catch (e) {
                    finish(null);
                }
            };
            iframe.onerror = () => finish(null);
            document.body.appendChild(iframe);
        } catch (e) {
            finish(null);
        }
    });
}
